import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { RootState } from '../../../../../../../../../../redux/store';
import {
  setShowDisabledTemplates,
  setVirtualMachineToConfigure,
  virtualMachinesSelectors,
} from '../../../../../../../../../../redux/configuration/virtual-machine-entities/slice';
import { TemplatesTable } from '.';

type TemplatesTableOwnProps = {
  loading: boolean;
  templateVms: InventoryVirtualMachine[];
  setShowMoreInfoForVmTemplate: ActionCreatorWithPayload<
    InventoryVirtualMachine | undefined,
    string
  >;
  topologyRemoteAccessCount: number;
  setShowRemoteAccessCountExceededModal?: ActionCreatorWithPayload<
    boolean,
    string
  >;
  isDiagramView: boolean;
};

const mapDispatchToProps = {
  setShowDisabledTemplates,
  setVirtualMachineToConfigure,
};

const mapStateToProps = (
  state: RootState,
  ownProps: TemplatesTableOwnProps,
) => ({
  ...ownProps,
  showDisabledTemplates:
    virtualMachinesSelectors.getShowDisabledTemplates(state),
});

export type TemplatesTableProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps>;

export const TemplatesTableContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TemplatesTable);
